<template>
  <article class="dictionary-term" :class="_class">
    <loader-dots v-if="loading" />

    <div 
      v-if="showError" 
      class="message"
    >
      {{ errorMessage }}
    </div>
    
    <div v-if="showTermInfo">
      <h1 class="term__title">
        {{ term.name }}
      </h1>

      <div
        v-for="(sense, index) in term.definitions"
        :key="sense.id"
        class="term__definitions"
      >
        <div v-if="sense.definition" class="term__definition">
          <div v-if="term.definitions.length > 1" class="term__iteration">
            {{ index + 1 }}
          </div>

          <div v-html="sense.definition"></div>
        </div>

        <div v-if="sense.nameEng" class="term__name-eng">
          {{ sense.nameEng }}
        </div>

        <template v-if="sense.shortname">
          <h2 class="term__label">
            <span class="term__label-text">Аббревиатура</span>
          </h2>

          <div 
            class="term__note" 
            v-html="sense.shortname"
          >  
          </div>
        </template>

        <div v-if="sense.synonym || sense.synonymnotrec" class="term__synonyms">
          <div v-if="sense.synonym" class="term__synonym">
            {{ sense.synonym }}
          </div>

          <div
            v-if="sense.synonymnotrec"
            title="Не рекомендуемые синонимы"
            class="term__synonym term__synonym_obsolete"
          >
            <svg width="18" height="18">
              <use xlink:href="#status--disabled" />
            </svg>
            <span>{{ sense.synonymnotrec }}</span>
          </div>
        </div>

        <template v-if="sense.lettering">
          <h2 class="term__label">
            <span class="term__label-text">Обозначение</span>
          </h2>

          <div class="term__note" v-html="sense.lettering"></div>
        </template>

        <template v-if="sense.note">
          <h2 class="term__label">
            <span class="term__label-text">Примечание</span>
          </h2>

          <div class="term__note" v-html="sense.note"></div>
          <!-- TODO: is it ok to use here html? <div class="term__note">{{ sense.note }}</div> -->
        </template>

        <template v-if="sense.area.length">
          <h2 class="term__label">
            <span class="term__label-text">Области</span>
          </h2>

          <ul class="term__extra term__area">
            <li
              v-for="singleArea in sense.area"
              :key="singleArea"
              class="term-extra__item"
            >
              {{ singleArea }}
            </li>
          </ul>
        </template>

        <template v-if="sense.sources.length">
          <h2 class="term__label">
            <span class="term__label-text">Источники</span>
          </h2>

          <ul class="term__extra term__sources">
            <li
              v-for="source in sense.sources"
              :key="source.id"
              class="term-extra__item term__source"
            >
              <div class="status term__status">
                <svg class="status__icon" width="22" height="22">
                  <use v-bind:xlink:href="getStatusIcon(source)" />
                </svg>

                <div v-if="source.statusHint" class="status__hint">
                  {{ source.statusHint }}
                </div>
              </div>

              <div>
                <router-link
                  v-if="source.id"
                  :to="makeDocumentRoute(source.id)"
                  class="term__doc"
                >
                  {{ source.title }}
                </router-link>

                <span v-else class="term__doc _no-link">
                  {{ source.title }}
                </span>

                <span v-if="source.comment" class="term__comment">
                  ({{ source.comment }})
                </span>
              </div>
            </li>
          </ul>
        </template>
      </div>
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex';

import DocumentRoute from '@@/document/mixins/DocumentRoute';

import LoaderDots from '@@/shared/loaders/LoaderDots';

export default {
  components: {
    LoaderDots
  },

  mixins: [DocumentRoute],

  props: {
    term: {
      type: [Object, String],
      required: true
    },
    noteTerm: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    _class: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState(['documentStatuses']),
    showError() {
      return this.noteTerm || (typeof(this.term) === 'string') 
    },
    showTermInfo() {
      return (typeof(this.term) === 'object') && Object.keys(this.term).length
    },
    errorMessage() {
      return this.showError? (this.noteTerm || this.term):'' 
    }
  },

  methods: {
    getStatusIcon(source) {
      return source.statusId
        ? this.documentStatuses[source.statusId].icon
        : '#status--na';
    }
  }
};
</script>
